import { render, staticRenderFns } from "./RoomUpdate.vue?vue&type=template&id=87e44280&"
import script from "./RoomUpdate.vue?vue&type=script&lang=js&"
export * from "./RoomUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports